module.exports = __webpack_public_path__ + "media/daji.f1d0e4eb.wav";